if (!customElements.get('photo-exhibit-swipe')) {
    class PhotoExhibitSwipe extends HTMLElement {
      /**
       * Section settings (only part)
       */
      sectionSettings;
  
      /**
       * Swiper entity
       * 
       * @type {Swiper}
       */
      mySwiper;
  
      constructor() {
        super();
        this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      }
  
      connectedCallback() {
        this.mySwiper = new Swiper(this.querySelector(`.swiper-container`), {
          loop: false,
          spaceBetween: 0,
          slidesPerView: 1,
          centeredSlides: false,
          observer: true,
          resizeObserver: true,
          navigation: {
            nextEl: this.querySelector(`.swiper-btn-next`),
            prevEl: this.querySelector(`.swiper-btn-prev`),
          },
          pagination: {
            el: this.querySelector(`#${this.id} .swiper-pagination`),
            clickable: true,
          },
          on: {
            slideChange: this.handleSlideChange.bind(this),
          },
          scrollbar: {
            el: this.querySelector(`#${this.id} .swiper-scrollbar`),
          },
          breakpoints: {
            1600: {
              slidesPerView: 3,
              spaceBetween: '12%'
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: '5%'
            },
            1000: {
              slidesPerView: 2.3,
              spaceBetween: '5%'
            },
            768: {
              slidesPerView: 1.5,
              spaceBetween: 30
            },
          },
        });
        this.initEvent();
      }
  
      /**
       * 轮播图切换事件
       */
      handleSlideChange(swiper) {
      }
  
      initEvent() {
      }
    }
  
    customElements.define('photo-exhibit-swipe', PhotoExhibitSwipe);
  }

